import { planTypes } from '@/common/constants';

const planType = planTypes.ZOOM_REVENUE_ACCELERATOR;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.planform.title.zoom_revenue_accelerator'),
      logo: require('@/assets/plans/zoom-revenue-accelerator.svg'),
    };
  },
};